<template>
  <div class="h-[100vh] py-5">
    <div class="relative z-50">
      <img
        alt=""
        class="w-[150px] object-cover self-center mx-auto"
        src="/images/logo.png"
      />
      <slot />
      <div class="flex gap-20 items-center justify-center font-semibold mt-5">
        <NuxtLink class="hover:text-blue-400" to="/privacy-policy"
          >Privacy Policy
        </NuxtLink>
        <NuxtLink class="hover:text-blue-400" to="/reset-link"
          >Terms & Conditions
        </NuxtLink>
        <NuxtLink class="hover:text-blue-400" to="/login">Sign In</NuxtLink>
      </div>
    </div>

    <div
      class="z-10 absolute bottom-[5px] flex justify-between w-full items-center"
    >
      <div class="max-w-[200px] sm:max-w-[280px]">
        <img alt="" class="object-cover" src="/images/login/footer_1.png" />
      </div>
      <div class="max-w-[200px] sm:max-w-[320px]">
        <img alt="" class="object-cover" src="/images/login/footer_2.png" />
      </div>
    </div>
  </div>
</template>
<style scoped>
.router-link-exact-active {
  color: rgb(20, 106, 246);
}
</style>
